/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Website API
 * The backend API for the website SPA
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import * as axios from 'axios';
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios'
import type {
  AddApplicationLineRequest,
  AddBasketLineRequest,
  BasketLineId,
  BasketResponse,
  DetailsResponse,
  GetBasketParams,
  HttpValidationProblemDetails,
  PatchBasketRequest,
  RemoveFromBasketParams,
  SelectedAccountConflict,
  UpdateBasketLineDiscountRequest,
  UpdateBasketLineRequest,
  UpdateLineDiscountParams,
  UpdateLineParams
} from './data.schemas'




export const getBasket = (
    segmentationId: number,
    params?: GetBasketParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BasketResponse>> => {
    
    return axios.default.get(
      `/api/segment/${encodeURIComponent(String(segmentationId))}/basket`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetBasketQueryKey = (segmentationId: number,
    params?: GetBasketParams,) => {
    return [`/api/segment/${segmentationId}/basket`, ...(params ? [params]: [])] as const;
    }

    
export const getGetBasketQueryOptions = <TData = Awaited<ReturnType<typeof getBasket>>, TError = AxiosError<SelectedAccountConflict>>(segmentationId: number,
    params?: GetBasketParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBasket>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBasketQueryKey(segmentationId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBasket>>> = ({ signal }) => getBasket(segmentationId,params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(segmentationId),  staleTime: 300000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBasket>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBasketQueryResult = NonNullable<Awaited<ReturnType<typeof getBasket>>>
export type GetBasketQueryError = AxiosError<SelectedAccountConflict>

export const useGetBasket = <TData = Awaited<ReturnType<typeof getBasket>>, TError = AxiosError<SelectedAccountConflict>>(
 segmentationId: number,
    params?: GetBasketParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBasket>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetBasketQueryOptions(segmentationId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetBasket = async <TData = Awaited<ReturnType<typeof getBasket>>, TError = AxiosError<SelectedAccountConflict>>(
 queryClient: QueryClient, segmentationId: number,
    params?: GetBasketParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBasket>>, TError, TData>>, axios?: AxiosRequestConfig}

  ): Promise<QueryClient> => {

  const queryOptions = getGetBasketQueryOptions(segmentationId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}


export const patchBasket = (
    segmentationId: number,
    patchBasketRequest: PatchBasketRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.default.patch(
      `/api/segment/${encodeURIComponent(String(segmentationId))}/basket`,
      patchBasketRequest,options
    );
  }



export const getPatchBasketMutationOptions = <TError = AxiosError<HttpValidationProblemDetails | SelectedAccountConflict>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchBasket>>, TError,{segmentationId: number;data: PatchBasketRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof patchBasket>>, TError,{segmentationId: number;data: PatchBasketRequest}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchBasket>>, {segmentationId: number;data: PatchBasketRequest}> = (props) => {
          const {segmentationId,data} = props ?? {};

          return  patchBasket(segmentationId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchBasketMutationResult = NonNullable<Awaited<ReturnType<typeof patchBasket>>>
    export type PatchBasketMutationBody = PatchBasketRequest
    export type PatchBasketMutationError = AxiosError<HttpValidationProblemDetails | SelectedAccountConflict>

    export const usePatchBasket = <TError = AxiosError<HttpValidationProblemDetails | SelectedAccountConflict>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchBasket>>, TError,{segmentationId: number;data: PatchBasketRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof patchBasket>>,
        TError,
        {segmentationId: number;data: PatchBasketRequest},
        TContext
      > => {

      const mutationOptions = getPatchBasketMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const deleteBasket = (
    segmentationId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.default.delete(
      `/api/segment/${encodeURIComponent(String(segmentationId))}/basket`,options
    );
  }



export const getDeleteBasketMutationOptions = <TError = AxiosError<SelectedAccountConflict>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBasket>>, TError,{segmentationId: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteBasket>>, TError,{segmentationId: number}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteBasket>>, {segmentationId: number}> = (props) => {
          const {segmentationId} = props ?? {};

          return  deleteBasket(segmentationId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteBasketMutationResult = NonNullable<Awaited<ReturnType<typeof deleteBasket>>>
    
    export type DeleteBasketMutationError = AxiosError<SelectedAccountConflict>

    export const useDeleteBasket = <TError = AxiosError<SelectedAccountConflict>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBasket>>, TError,{segmentationId: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteBasket>>,
        TError,
        {segmentationId: number},
        TContext
      > => {

      const mutationOptions = getDeleteBasketMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const getBasketQuantity = (
    segmentationId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<number>> => {
    
    return axios.default.get(
      `/api/segment/${encodeURIComponent(String(segmentationId))}/basket/totalquantity`,options
    );
  }


export const getGetBasketQuantityQueryKey = (segmentationId: number,) => {
    return [`/api/segment/${segmentationId}/basket/totalquantity`] as const;
    }

    
export const getGetBasketQuantityQueryOptions = <TData = Awaited<ReturnType<typeof getBasketQuantity>>, TError = AxiosError<SelectedAccountConflict>>(segmentationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBasketQuantity>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBasketQuantityQueryKey(segmentationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBasketQuantity>>> = ({ signal }) => getBasketQuantity(segmentationId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(segmentationId),  staleTime: 300000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBasketQuantity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetBasketQuantityQueryResult = NonNullable<Awaited<ReturnType<typeof getBasketQuantity>>>
export type GetBasketQuantityQueryError = AxiosError<SelectedAccountConflict>

export const useGetBasketQuantity = <TData = Awaited<ReturnType<typeof getBasketQuantity>>, TError = AxiosError<SelectedAccountConflict>>(
 segmentationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBasketQuantity>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetBasketQuantityQueryOptions(segmentationId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetBasketQuantity = async <TData = Awaited<ReturnType<typeof getBasketQuantity>>, TError = AxiosError<SelectedAccountConflict>>(
 queryClient: QueryClient, segmentationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBasketQuantity>>, TError, TData>>, axios?: AxiosRequestConfig}

  ): Promise<QueryClient> => {

  const queryOptions = getGetBasketQuantityQueryOptions(segmentationId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}


export const getOpportunityReadOnlyDetails = (
    segmentationId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<DetailsResponse>> => {
    
    return axios.default.get(
      `/api/segment/${encodeURIComponent(String(segmentationId))}/basket/details`,options
    );
  }


export const getGetOpportunityReadOnlyDetailsQueryKey = (segmentationId: number,) => {
    return [`/api/segment/${segmentationId}/basket/details`] as const;
    }

    
export const getGetOpportunityReadOnlyDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getOpportunityReadOnlyDetails>>, TError = AxiosError<SelectedAccountConflict>>(segmentationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOpportunityReadOnlyDetails>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOpportunityReadOnlyDetailsQueryKey(segmentationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOpportunityReadOnlyDetails>>> = ({ signal }) => getOpportunityReadOnlyDetails(segmentationId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(segmentationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOpportunityReadOnlyDetails>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOpportunityReadOnlyDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getOpportunityReadOnlyDetails>>>
export type GetOpportunityReadOnlyDetailsQueryError = AxiosError<SelectedAccountConflict>

export const useGetOpportunityReadOnlyDetails = <TData = Awaited<ReturnType<typeof getOpportunityReadOnlyDetails>>, TError = AxiosError<SelectedAccountConflict>>(
 segmentationId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOpportunityReadOnlyDetails>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetOpportunityReadOnlyDetailsQueryOptions(segmentationId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const addToBasket = (
    segmentationId: number,
    addBasketLineRequest: AddBasketLineRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BasketLineId>> => {
    
    return axios.default.post(
      `/api/segment/${encodeURIComponent(String(segmentationId))}/basket/lines`,
      addBasketLineRequest,options
    );
  }



export const getAddToBasketMutationOptions = <TError = AxiosError<void | SelectedAccountConflict>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addToBasket>>, TError,{segmentationId: number;data: AddBasketLineRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof addToBasket>>, TError,{segmentationId: number;data: AddBasketLineRequest}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addToBasket>>, {segmentationId: number;data: AddBasketLineRequest}> = (props) => {
          const {segmentationId,data} = props ?? {};

          return  addToBasket(segmentationId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AddToBasketMutationResult = NonNullable<Awaited<ReturnType<typeof addToBasket>>>
    export type AddToBasketMutationBody = AddBasketLineRequest
    export type AddToBasketMutationError = AxiosError<void | SelectedAccountConflict>

    export const useAddToBasket = <TError = AxiosError<void | SelectedAccountConflict>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addToBasket>>, TError,{segmentationId: number;data: AddBasketLineRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof addToBasket>>,
        TError,
        {segmentationId: number;data: AddBasketLineRequest},
        TContext
      > => {

      const mutationOptions = getAddToBasketMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const updateLine = (
    segmentationId: number,
    lineId: number,
    updateBasketLineRequest: UpdateBasketLineRequest,
    params?: UpdateLineParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BasketResponse>> => {
    
    return axios.default.put(
      `/api/segment/${encodeURIComponent(String(segmentationId))}/basket/lines/${encodeURIComponent(String(lineId))}`,
      updateBasketLineRequest,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getUpdateLineMutationOptions = <TError = AxiosError<HttpValidationProblemDetails | SelectedAccountConflict>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLine>>, TError,{segmentationId: number;lineId: number;data: UpdateBasketLineRequest;params?: UpdateLineParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateLine>>, TError,{segmentationId: number;lineId: number;data: UpdateBasketLineRequest;params?: UpdateLineParams}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLine>>, {segmentationId: number;lineId: number;data: UpdateBasketLineRequest;params?: UpdateLineParams}> = (props) => {
          const {segmentationId,lineId,data,params} = props ?? {};

          return  updateLine(segmentationId,lineId,data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateLineMutationResult = NonNullable<Awaited<ReturnType<typeof updateLine>>>
    export type UpdateLineMutationBody = UpdateBasketLineRequest
    export type UpdateLineMutationError = AxiosError<HttpValidationProblemDetails | SelectedAccountConflict>

    export const useUpdateLine = <TError = AxiosError<HttpValidationProblemDetails | SelectedAccountConflict>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLine>>, TError,{segmentationId: number;lineId: number;data: UpdateBasketLineRequest;params?: UpdateLineParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof updateLine>>,
        TError,
        {segmentationId: number;lineId: number;data: UpdateBasketLineRequest;params?: UpdateLineParams},
        TContext
      > => {

      const mutationOptions = getUpdateLineMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const removeFromBasket = (
    segmentationId: number,
    lineId: number,
    params?: RemoveFromBasketParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BasketResponse>> => {
    
    return axios.default.delete(
      `/api/segment/${encodeURIComponent(String(segmentationId))}/basket/lines/${encodeURIComponent(String(lineId))}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getRemoveFromBasketMutationOptions = <TError = AxiosError<SelectedAccountConflict>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeFromBasket>>, TError,{segmentationId: number;lineId: number;params?: RemoveFromBasketParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof removeFromBasket>>, TError,{segmentationId: number;lineId: number;params?: RemoveFromBasketParams}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeFromBasket>>, {segmentationId: number;lineId: number;params?: RemoveFromBasketParams}> = (props) => {
          const {segmentationId,lineId,params} = props ?? {};

          return  removeFromBasket(segmentationId,lineId,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RemoveFromBasketMutationResult = NonNullable<Awaited<ReturnType<typeof removeFromBasket>>>
    
    export type RemoveFromBasketMutationError = AxiosError<SelectedAccountConflict>

    export const useRemoveFromBasket = <TError = AxiosError<SelectedAccountConflict>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeFromBasket>>, TError,{segmentationId: number;lineId: number;params?: RemoveFromBasketParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof removeFromBasket>>,
        TError,
        {segmentationId: number;lineId: number;params?: RemoveFromBasketParams},
        TContext
      > => {

      const mutationOptions = getRemoveFromBasketMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const updateLineDiscount = (
    segmentationId: number,
    lineId: number,
    updateBasketLineDiscountRequest: UpdateBasketLineDiscountRequest,
    params?: UpdateLineDiscountParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BasketResponse>> => {
    
    return axios.default.put(
      `/api/segment/${encodeURIComponent(String(segmentationId))}/basket/lines/discount/${encodeURIComponent(String(lineId))}`,
      updateBasketLineDiscountRequest,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getUpdateLineDiscountMutationOptions = <TError = AxiosError<HttpValidationProblemDetails | SelectedAccountConflict>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLineDiscount>>, TError,{segmentationId: number;lineId: number;data: UpdateBasketLineDiscountRequest;params?: UpdateLineDiscountParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateLineDiscount>>, TError,{segmentationId: number;lineId: number;data: UpdateBasketLineDiscountRequest;params?: UpdateLineDiscountParams}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLineDiscount>>, {segmentationId: number;lineId: number;data: UpdateBasketLineDiscountRequest;params?: UpdateLineDiscountParams}> = (props) => {
          const {segmentationId,lineId,data,params} = props ?? {};

          return  updateLineDiscount(segmentationId,lineId,data,params,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateLineDiscountMutationResult = NonNullable<Awaited<ReturnType<typeof updateLineDiscount>>>
    export type UpdateLineDiscountMutationBody = UpdateBasketLineDiscountRequest
    export type UpdateLineDiscountMutationError = AxiosError<HttpValidationProblemDetails | SelectedAccountConflict>

    export const useUpdateLineDiscount = <TError = AxiosError<HttpValidationProblemDetails | SelectedAccountConflict>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLineDiscount>>, TError,{segmentationId: number;lineId: number;data: UpdateBasketLineDiscountRequest;params?: UpdateLineDiscountParams}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof updateLineDiscount>>,
        TError,
        {segmentationId: number;lineId: number;data: UpdateBasketLineDiscountRequest;params?: UpdateLineDiscountParams},
        TContext
      > => {

      const mutationOptions = getUpdateLineDiscountMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const addApplicationToBasket = (
    segmentationId: number,
    addApplicationLineRequest: AddApplicationLineRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BasketLineId>> => {
    
    return axios.default.post(
      `/api/segment/${encodeURIComponent(String(segmentationId))}/basket/application-lines`,
      addApplicationLineRequest,options
    );
  }



export const getAddApplicationToBasketMutationOptions = <TError = AxiosError<void | SelectedAccountConflict>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addApplicationToBasket>>, TError,{segmentationId: number;data: AddApplicationLineRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof addApplicationToBasket>>, TError,{segmentationId: number;data: AddApplicationLineRequest}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addApplicationToBasket>>, {segmentationId: number;data: AddApplicationLineRequest}> = (props) => {
          const {segmentationId,data} = props ?? {};

          return  addApplicationToBasket(segmentationId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AddApplicationToBasketMutationResult = NonNullable<Awaited<ReturnType<typeof addApplicationToBasket>>>
    export type AddApplicationToBasketMutationBody = AddApplicationLineRequest
    export type AddApplicationToBasketMutationError = AxiosError<void | SelectedAccountConflict>

    export const useAddApplicationToBasket = <TError = AxiosError<void | SelectedAccountConflict>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addApplicationToBasket>>, TError,{segmentationId: number;data: AddApplicationLineRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof addApplicationToBasket>>,
        TError,
        {segmentationId: number;data: AddApplicationLineRequest},
        TContext
      > => {

      const mutationOptions = getAddApplicationToBasketMutationOptions(options);

      return useMutation(mutationOptions);
    }
    